export enum RegistryModerationTab {
  Submitted = 'submitted',
  Pending = 'pending',
  Moderators = 'moderators',
  Settings = 'settings',
}
